import script from "./footer-one.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-one.vue?vue&type=script&setup=true&lang=js"

import "./footer-one.vue?vue&type=style&index=0&id=00749590&lang=css"

const __exports__ = script;

export default __exports__